import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

import { invalidateSession } from './invalidate-session';

/**
 * Shown by `AuthenticationGuard` when the JWT parses fine but the caller
 * is neither `superadmin` nor internal Cliengo staff (email not
 * `@cliengo.com`/`@leadaki.com`).
 *
 * The "Cerrar sesión" button calls `invalidateSession()`, which drops
 * the cookie and signals the guard to drop to `NoJwtScreen` — useful
 * when the wrong user is logged in (e.g. a customer account) and you
 * need to switch.
 */
export const NoPermissionsScreen = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 2,
      py: 6,
    }}
  >
    <Card sx={{ maxWidth: 480, width: '100%' }}>
      <CardContent>
        <Stack spacing={2} alignItems="flex-start">
          <Box
            sx={{
              bgcolor: 'warning.light',
              color: 'warning.dark',
              width: 44,
              height: 44,
              borderRadius: 999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <BlockOutlinedIcon />
          </Box>
          <Typography variant="h5" component="h1">
            No tenés permisos para ver esta aplicación
          </Typography>
          <Typography variant="body2" color="text.secondary">
            HSM Admin es una herramienta interna: requiere privilegio{' '}
            <code>superadmin</code> o un email de Cliengo (
            <code>@cliengo.com</code> / <code>@leadaki.com</code>). Si necesitás
            acceso, hablá con tu administrador.
          </Typography>
          <Button
            variant="outlined"
            onClick={invalidateSession}
            sx={{ alignSelf: 'flex-start' }}
          >
            Cerrar sesión
          </Button>
        </Stack>
      </CardContent>
    </Card>
  </Box>
);
